import 'amfe-flexible'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { 
  Carousel, 
  CarouselItem,
  Tabs,
  TabPane,
  Popover,
  Row,
  Col,
  Collapse,
  CollapseItem,
  Message
} from 'element-ui'

// 注册组件
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Popover)
Vue.use(Row)
Vue.use(Col)
Vue.use(Collapse)
Vue.use(CollapseItem)

// Message 特殊处理
Vue.prototype.$message = Message

// 引入基础样式（必须）
import 'element-ui/lib/theme-chalk/base.css'
import 'element-ui/lib/theme-chalk/icon.css'

// 按需引入组件样式
import 'element-ui/lib/theme-chalk/carousel.css'
import 'element-ui/lib/theme-chalk/carousel-item.css'

import 'element-ui/lib/theme-chalk/tabs.css'
import 'element-ui/lib/theme-chalk/popover.css'
import 'element-ui/lib/theme-chalk/collapse.css'
// Row/Col 样式包含在 grid.css 中
import 'element-ui/lib/theme-chalk/row.css'
import 'element-ui/lib/theme-chalk/col.css'

import intersectionObserverPlugin from './plugins/intersectionObserver'
// import VueAMap from 'vue-amap'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '', 
  loading: '', 
  attempt: 1
})
Vue.config.productionTip = false
// Vue.use(VueAMap)
Vue.use(intersectionObserverPlugin)

router.beforeEach((to, from, next) => {
  // 如果路由有 meta.title，则设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    // 设置默认标题
    document.title = '蓝悦无人机 - 智能无人系统全链路解决方案'
  }
  next()
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')